import { service } from '../../../../helpers/http' 

export const ActionGetEducationalGroups = ({ dispatch }, payload) => { 
    return service({
        module: 'domainEducationalGroup',
        action: 'getEducationalGroups',
        payload: payload
    })
}

export const ActionPostEducationalGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainEducationalGroup',
        action: 'postEducationalGroups',
        payload: payload
    })
    
}

export const ActionPutEducationalGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainEducationalGroup',
        action: 'putEducationalGroups',
        payload: payload
    })
    
}

export const ActionDeleteEducationalGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainEducationalGroup',
        action: 'deleteEducationalGroups',
        payload: payload
    })
    
}
